import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const NavigationLastIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.59009 7.41L10.1801 12L5.59009 16.59L7.00009 18L13.0001 12L7.00009 6L5.59009 7.41ZM16.0001 6H18.0001V18H16.0001V6Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  },
)
